import * as fromReducer from './certificate.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Certificate, CertificateState } from './certificate.state';
import { DevicesRouterStoreSelectors } from '../router';

export const selectCertificateState = createFeatureSelector<CertificateState>(fromReducer.MdmCertificateFeatureKey);

export const selectCertificates = createSelector(selectCertificateState, fromReducer.selectCertificates);

export const selectCertificateIds = createSelector(selectCertificateState, fromReducer.selectCertificateIds);

export const selectCertificateEntities = createSelector(selectCertificateState, fromReducer.selectCertificateEntities);

export const selectCertificatesByUdid = createSelector(
  selectCertificates,
  DevicesRouterStoreSelectors.selectUdid,
  (certificates: Certificate[], udid: string) => certificates.filter((certificate) => certificate.udid === udid)
);
